// extracted by mini-css-extract-plugin
export default {"errorMessage":"ErrorHandler_errorMessage__j6lgl"};